// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/webpack-hot-middleware/client.js?path=http://localhost:3000/__webpack_hmr");
var __webpack_exports__ = __webpack_require__("./index.js");
